<div class="leads-container">
  <div class="title-section">
    <h3 class="section-title">Leads</h3>
    <div class="toolbar-actions">
      <button type="button" class="filter-btn" (click)="toggleFilterPanel()">
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M2 4H14M4.66667 8H11.3333M6.66667 12H9.33333"
            stroke="#15172E"
            stroke-width="1.25"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <span>Filter</span>
      </button>
      <div class="search-field">
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z"
            stroke="#A7ABB3"
            stroke-width="1.25"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M14 14L11.1 11.1"
            stroke="#A7ABB3"
            stroke-width="1.25"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <input
          type="text"
          class="search-input"
          placeholder="Search for number"
          [(ngModel)]="searchQuery"
          (ngModelChange)="onSearchChange()"
        />
      </div>
      <button
        type="button"
        class="export-btn"
        [disabled]="exporting || loading || exportTotal === 0"
        (click)="exportLeads()"
      >
        {{ exporting ? 'Exporting…' : 'Export' }}
      </button>
    </div>
  </div>

  <div class="filter-panel" *ngIf="showFilterPanel">
    <div class="filter-group">
      <span class="filter-label">Event type</span>
      <div class="filter-chip-group">
        <button
          type="button"
          *ngFor="let eventType of eventTypeOptions; trackBy: trackByIndex"
          class="filter-chip"
          [class.active]="isDraftEventTypeSelected(eventType)"
          (click)="toggleDraftEventType(eventType)"
        >
          {{ getFilterEventTypeLabel(eventType) }}
        </button>
      </div>
    </div>
    <div class="filter-actions">
      <button
        type="button"
        class="filter-action-btn secondary"
        [disabled]="!canResetFilters()"
        (click)="resetFilters()"
      >
        Reset
      </button>
      <button type="button" class="filter-action-btn primary" (click)="applyFilters()">
        Apply
      </button>
    </div>
  </div>

  <div class="leads-list">
    <div *ngIf="loading" class="state-message">
      <div class="spinner"></div>
      <p>Loading leads...</p>
    </div>

    <div *ngIf="error && !loading" class="state-message error">
      <p>{{ error }}</p>
      <button type="button" class="retry-btn" (click)="loadLeads()">Retry</button>
    </div>

    <div *ngIf="!loading && !error && filteredLeads.length === 0" class="state-message">
      <p>No leads found.</p>
    </div>

    <div *ngFor="let lead of filteredLeads; trackBy: trackByLeadId" class="lead-card">
      <div class="lead-header">
        <h4 class="lead-primary">{{ getLeadPrimaryLabel(lead) }}</h4>
        <span class="status-badge" [ngClass]="getStatusClass(getEventType(lead))">
          {{ getStatusLabel(getEventType(lead)) }}
        </span>
      </div>

      <div class="divider"></div>

      <div class="lead-details-grid">
        <div class="detail-item">
          <span class="detail-label">SOURCE</span>
          <span class="detail-value">{{ getPlatformLabel(lead) }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">CAMPAIGN CLICKED</span>
          <span class="detail-value">{{ formatDateTime(lead.campaign_clicked_at) }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">LANDING PAGE VIEWED</span>
          <span class="detail-value">{{ formatDateTime(lead.landing_page_viewed_at) }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">PHONE NUMBER ADDED</span>
          <span class="detail-value">{{ formatDateTime(lead.offer_received_at) }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">PAYMENT TIME</span>
          <span class="detail-value">{{ getPaymentTime(lead) }}</span>
        </div>
      </div>
    </div>

    <div class="pagination" *ngIf="!loading && !error && total > limit">
      <button
        type="button"
        class="pagination-btn"
        [disabled]="page <= 1"
        (click)="goToPreviousPage()"
      >
        Previous
      </button>
      <span class="pagination-info">Page {{ page }} of {{ Math.ceil(total / limit) || 1 }}</span>
      <button
        type="button"
        class="pagination-btn"
        [disabled]="page * limit >= total"
        (click)="goToNextPage()"
      >
        Next
      </button>
    </div>
  </div>
</div>
